import { useEffect } from "react";
import "@/App.css";
import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";
import { Toaster } from "@/components/ui/sonner";
import { AuthProvider, useAuth } from "@/context/AuthContext";
import { ProtectedRoute } from "@/components/ProtectedRoute";
import { AppLayout } from "@/components/AppLayout";

import Landing from "@/pages/Landing";
import Login from "@/pages/Login";
import Register from "@/pages/Register";
import Dashboard from "@/pages/Dashboard";
import Scanner from "@/pages/Scanner";
import Vault from "@/pages/Vault";
import Letters from "@/pages/Letters";
import Impots from "@/pages/Impots";
import Rights from "@/pages/Rights";
import Subscription from "@/pages/Subscription";
import PaymentSuccess from "@/pages/PaymentSuccess";
import Account from "@/pages/Account";

function Shell({ children }) {
  return (
    <ProtectedRoute>
      <AppLayout>{children}</AppLayout>
    </ProtectedRoute>
  );
}

function PublicOnly({ children }) {
  const { user } = useAuth();
  if (user) return <Navigate to="/app" replace />;
  return children;
}

function App() {
  return (
    <div className="App">
      <BrowserRouter>
        <AuthProvider>
          <Routes>
            <Route path="/" element={<Landing />} />
            <Route path="/connexion" element={<PublicOnly><Login /></PublicOnly>} />
            <Route path="/inscription" element={<PublicOnly><Register /></PublicOnly>} />

            <Route path="/app" element={<Shell><Dashboard /></Shell>} />
            <Route path="/app/scanner" element={<Shell><Scanner /></Shell>} />
            <Route path="/app/coffre-fort" element={<Shell><Vault /></Shell>} />
            <Route path="/app/courriers" element={<Shell><Letters /></Shell>} />
            <Route path="/app/impots" element={<Shell><Impots /></Shell>} />
            <Route path="/app/droits" element={<Shell><Rights /></Shell>} />
            <Route path="/app/abonnement" element={<Shell><Subscription /></Shell>} />
            <Route path="/app/compte" element={<Shell><Account /></Shell>} />
            <Route path="/payment/success" element={<Shell><PaymentSuccess /></Shell>} />

            <Route path="*" element={<Navigate to="/" replace />} />
          </Routes>
          <Toaster position="top-center" richColors />
        </AuthProvider>
      </BrowserRouter>
    </div>
  );
}

export default App;
